import { Content } from 'antd/es/layout/layout';
import Foot from './footer/foot';
import Navbar from './navbar/navbar';
import { Loading } from 'src/components/loaging/Loading';
import { Outlet } from 'react-router-dom';
import GuardedRoute from '../../routes/GuardRoute';
import { useEffect, useState } from 'react';
import { Button, Row, Tooltip } from 'antd';
import { MessageOutlined } from '@ant-design/icons';
import { LinkConstants } from 'src/constant/linkConstants';
import { useSessionContext } from 'src/context/session-context';
import signalRService from 'src/services/signalrService';

interface IProps {
  isShowSearch?: boolean;
  forceAuthentication?: boolean;
}

export default function AppLayout({ forceAuthentication = true, isShowSearch = true }: IProps) {
  const [isLoading, setIsLoading] = useState(false);
  const { signOut } = useSessionContext();

  useEffect(() => {
    setIsLoading(true);

    const onPageLoad = () => {
      setIsLoading(false);
    };

    if (document.readyState === 'complete') {
      onPageLoad();
    } else {
      window.addEventListener('load', onPageLoad);
      return () => window.removeEventListener('load', onPageLoad);
    }
  }, []);

  useEffect(() => {
    signalRService.restartConnection(signOut);

    return () => {
      signalRService.stopConnection();
    };
  }, []);

  return (
    <>
      <Row justify={'end'} className='sticky-position'>
        <Tooltip
          color={'#108ee9'}
          title="Feel Free to chat with Alive United">
          <Button
            onClick={() => window.open(LinkConstants.FacebookMessage, '_blank')}
            type='primary'
            size='large'
            className='btn-icon- ms-2 message-margin'
            shape='circle'
            icon={<MessageOutlined />}
          />
        </Tooltip>
      </Row>
      <Navbar isShowSearch={isShowSearch} />
      <Content className='content-fixed-height'>
        <GuardedRoute forceAuthentication={forceAuthentication}>
          <>
            <Loading isLoading={isLoading} />
            <Outlet />
          </>
        </GuardedRoute>
      </Content>
      <Foot />
    </>
  );
}
